module.exports = __webpack_public_path__ + "media/site_templates/www.hirelocalelectricians.com.au/images/feature_1-f5452ddbd66608b8ab9f98c6aef5cea1.jpeg";